<template>
  <v-container fluid>
    <v-card border="0" elevation="0">
      <v-card-title class="mb-10 mt-4" align="left">
        <v-row>
          <v-col
            ><h2>Экспертиза {{ title }}</h2></v-col
          >
          <v-col>
            <h3>
              ООО "Стройтехнология" ГИП Будилов Дмитрий Валерьевич +79142725513
            </h3></v-col
          >
        </v-row>
      </v-card-title>
      <v-card-text class="mb-5" align="left">
        <p><b>Объект:</b> {{ obj }}</p>
        <p><b>Раздел: </b>{{ this.sections }}</p>
        <p><b>Эксперт: </b>{{ this.expert.name }}</p>
        <p>
          <b></b
          ><a :href="`tel:${this.expert.phone}`">{{ this.expert.phone }}</a>
        </p>
      </v-card-text>
      <v-row>
        <v-col cols="4" align="left" class="ml-3">
          <h5>
            МАТЕРИАЛЫ ПО ЭКСПЕРТИЗЕ:
            <v-btn
              class="text-none"
              color="blue"
              prepend-icon="mdi-download-circle"
              variant="text"
              :href="b24DiskUrl"
              target="_blank"
            >
              Посмотреть документацию
            </v-btn>
          </h5>
        </v-col>
        <v-col cols="3" align="left" align-self="center" class="ml-3"
          ><b>{{
            disabled ? "Принято" : `Срок рассмотрения: ${this.lastDate}`
          }}</b></v-col
        >
      </v-row>
    </v-card>
    <template v-if="loadingValue < 100 && loadingValue > 0">
      <v-row>
        <v-col>
          <v-progress-circular
            :model-value="loadingValue"
            :rotate="360"
            :size="100"
            :width="15"
            color="blue"
            class="mt-10 mt-4"
          >
            {{ loadingValue.toFixed(0) }}
          </v-progress-circular>
        </v-col>
      </v-row>
    </template>
    <template v-else>
      <v-row class="answer" no-gutters>
        <v-col
          :cols="isMobile ? 12 : 7"
          :offset="isMobile ? 0 : item.type == 'question' ? 0 : 5"
          v-for="(item, index) in items"
          :key="item.id"
          align-self="center"
        >
          <v-card class="mt-10 rounded-xl">
            <v-table>
              <thead>
                <tr>
                  <th class="text-center" style="background-color: #e4e7ef">
                    Дата
                  </th>
                  <th class="text-center" style="background-color: #e4e7ef">
                    N
                  </th>
                  <th style="background-color: #e4e7ef">
                    {{
                      item.localResult
                        ? "Локальное заключение"
                        : item.type == "question"
                        ? "Замечания эксперта по документации"
                        : "Ответ на замечание"
                    }}
                  </th>
                  <th
                    style="background-color: #e4e7ef"
                    v-show="index + 1 == items.length && item.date == nowDate"
                  >
                    <v-btn
                      density="compact"
                      icon="mdi-close"
                      color="#e4e7ef"
                      @click="deleteItem(item)"
                    ></v-btn>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ item.date }}</td>
                  <td>{{ index + 1 }}</td>
                  <td>
                    <v-card-actions class="flex-column align-start">
                      <v-btn
                        v-for="file in item.files"
                        :key="file.id"
                        class="ml-2 me-2 text-none"
                        color="blue"
                        prepend-icon="mdi-download"
                        variant="text"
                        @click="download('file', file)"
                      >
                        {{ `${file.title} | ${file.hash}` }}
                      </v-btn>
                      <v-btn
                        class="ml-2 me-2 text-none"
                        color="blue"
                        prepend-icon="mdi-download-circle"
                        variant="text"
                        @click="download('all')"
                      >
                        Скачать все файлы
                      </v-btn>
                    </v-card-actions>
                  </td>
                </tr>
              </tbody>
            </v-table>
          </v-card>
        </v-col>
      </v-row>
      <v-row class="form">
        <v-col :cols="isMobile ? 12 : 7">
          <v-card class="mt-10 rounded-xl">
            <v-table>
              <thead>
                <tr>
                  <th class="text-center" style="background-color: #e4e7ef">
                    Дата
                  </th>
                  <th class="text-center" style="background-color: #e4e7ef">
                    N
                  </th>
                  <th class="text-center" style="background-color: #e4e7ef">
                    {{ isExpert ? "Замечание эксперта" : "Ответ на замечание" }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{ date.toLocaleDateString("ru-RU") }}</td>
                  <td>{{ items.length + 1 }}</td>
                  <td>
                    <v-row v-if="isExpert == 'true'" v-show="!isMobile">
                      <v-col>
                        <v-btn
                          @click="expertMenu = !expertMenu"
                          class="rounded-lg text-none mr-5"
                          variant="flat"
                          color="blue"
                          >Добавить замечание</v-btn
                        >
                        <v-dialog
                          v-model="expertMenu"
                          width="600"
                          class="rounded-lg"
                        >
                          <v-card title="Добавьте ваше замечание">
                            <v-tooltip
                              text="Можно добавлять несколько файлов!"
                              location="top"
                            >
                              <template v-slot:activator="{ props }">
                                <v-file-input
                                  v-bind="props"
                                  :disabled="disabled"
                                  v-model="files"
                                  color="blue"
                                  counter
                                  variant="outlined"
                                  prepend-icon=""
                                  prepend-inner-icon="mdi-paperclip"
                                  :clearable="false"
                                  class="ma-10"
                                  multiple
                                  placeholder="Добавить файл(ы)"
                                  density="compact"
                                  hide-details
                                >
                                  <template v-slot:selection="{ fileNames }">
                                    <v-chip-group
                                      column
                                      direction="vertical"
                                      color="blue"
                                      class="text-blue"
                                    >
                                      <v-chip
                                        v-for="fileName in fileNames"
                                        :key="fileName"
                                        label
                                        class="me-2"
                                      >
                                        {{ fileName }}
                                      </v-chip>
                                    </v-chip-group>
                                  </template>
                                </v-file-input>
                              </template>
                            </v-tooltip>
                            <template v-slot:actions>
                              <v-btn
                                :disabled="disabled || files.length == 0"
                                @click="upload('Подрядчик')"
                                class="ms-auto"
                                text="Сохранить"
                              ></v-btn>
                            </template>
                          </v-card>
                        </v-dialog>
                        <v-btn
                          @click="expertLocalMenu = !expertLocalMenu"
                          class="rounded-lg text-none"
                          variant="flat"
                          color="success"
                          >Принято</v-btn
                        >
                        <v-dialog v-model="expertLocalMenu" width="600">
                          <v-card
                            title="Добавьте итоговый раздел документации!"
                          >
                            <v-tooltip
                              text="Можно добавлять несколько файлов!"
                              location="top"
                            >
                              <template v-slot:activator="{ props }">
                                <v-file-input
                                  v-bind="props"
                                  :disabled="disabled"
                                  v-model="files"
                                  color="blue"
                                  counter
                                  variant="outlined"
                                  prepend-icon=""
                                  prepend-inner-icon="mdi-paperclip"
                                  :clearable="false"
                                  class="ma-10"
                                  multiple
                                  label="Итоговый раздел документации"
                                  placeholder="Итоговый раздел документации"
                                  density="compact"
                                  hide-details
                                >
                                  <template v-slot:selection="{ fileNames }">
                                    <v-chip-group
                                      column
                                      direction="vertical"
                                      color="blue"
                                      class="text-blue"
                                    >
                                      <v-chip
                                        v-for="fileName in fileNames"
                                        :key="fileName"
                                        label
                                        class="me-2"
                                      >
                                        {{ fileName }}
                                      </v-chip>
                                    </v-chip-group>
                                  </template>
                                </v-file-input>
                              </template>
                            </v-tooltip>
                            <v-tooltip
                              text="Можно добавлять несколько файлов!"
                              location="top"
                            >
                              <template v-slot:activator="{ props }">
                                <v-file-input
                                  v-bind="props"
                                  :disabled="disabled"
                                  v-model="localFiles"
                                  color="blue"
                                  counter
                                  variant="outlined"
                                  prepend-icon=""
                                  prepend-inner-icon="mdi-paperclip"
                                  :clearable="false"
                                  class="ma-10"
                                  multiple
                                  label="Локальное заключение"
                                  placeholder="Локальное заключение"
                                  density="compact"
                                  hide-details
                                >
                                  <template v-slot:selection="{ fileNames }">
                                    <v-chip-group
                                      column
                                      direction="vertical"
                                      color="blue"
                                      class="text-blue"
                                    >
                                      <v-chip
                                        v-for="fileName in fileNames"
                                        :key="fileName"
                                        label
                                        class="me-2"
                                      >
                                        {{ fileName }}
                                      </v-chip>
                                    </v-chip-group>
                                  </template>
                                </v-file-input>
                              </template>
                            </v-tooltip>
                            <template v-slot:actions>
                              <v-btn
                                :disabled="disabled || files.length == 0"
                                @click="upload('Принято')"
                                class="ms-auto"
                                text="Сохранить"
                              ></v-btn>
                            </template>
                          </v-card>
                        </v-dialog>
                      </v-col>
                    </v-row>
                    <v-row v-if="isExpert == 'true'" v-show="isMobile">
                      <v-row>
                        <v-col cols="12">
                          <v-btn
                            @click="expertMenu = !expertMenu"
                            class="rounded-lg text-none"
                            variant="flat"
                            color="blue"
                            >Добавить замечание</v-btn
                          >
                          <v-btn
                            @click="expertLocalMenu = !expertLocalMenu"
                            class="rounded-lg text-none"
                            variant="flat"
                            color="success"
                            >Принято</v-btn
                          >
                        </v-col>
                      </v-row>
                    </v-row>
                    <v-tooltip
                      v-else
                      text="Можно добавлять несколько файлов!"
                      location="top"
                    >
                      <template v-slot:activator="{ props }">
                        <v-file-input
                          v-bind="props"
                          :disabled="disabled"
                          v-model="files"
                          color="blue"
                          counter
                          variant="outlined"
                          prepend-icon=""
                          prepend-inner-icon="mdi-paperclip"
                          :clearable="false"
                          class="mt-2 mb-2"
                          multiple
                          placeholder="Добавить файл(ы)"
                          density="compact"
                          hide-details
                        >
                          <template v-slot:selection="{ fileNames }">
                            <v-chip-group
                              column
                              direction="vertical"
                              color="blue"
                              class="text-blue"
                            >
                              <v-chip
                                v-for="fileName in fileNames"
                                :key="fileName"
                                label
                                class="me-2"
                              >
                                {{ fileName }}
                              </v-chip>
                            </v-chip-group>
                          </template>
                        </v-file-input>
                      </template>
                    </v-tooltip>
                  </td>
                </tr>
              </tbody>
            </v-table>
            <v-divider></v-divider>
            <v-card-actions
              class="justify-end mr-4 text-none"
              v-if="!isExpert || isExpert == 'false'"
            >
              <v-btn
                :disabled="disabled || files.length == 0"
                @click="upload('Клиент')"
                class="rounded-lg"
                variant="flat"
                color="blue"
                >Добавить ответ на замечание</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "HomeView",
  components: {},
  data: () => ({
    expertMenu: false,
    expertLocalMenu: false,
    loadingValue: 0,
    dateNow: "",
    expert: {
      name: "",
      phone: "",
      email: "",
    },
    lastDate: "",
    disabled: false,
    date: new Date(),
    sections: "",
    title: "",
    obj: "",
    chatID: null,
    deal: {},
    isExpert: true,
    files: [],
    localFiles: [],
    //dealFiles: [],
    b24DiskUrl: "",
    width: 0,
    isMobile: false,
    items: [],
    url: "https://sudexpert.bitrix24.ru/rest/816/v3rsh7wds1p4roy5/",
  }),
  methods: {
    async deleteItem(item) {
      try {
        console.log(item);
        const needItemIndex = this.items.findIndex((e) => e.id == item.id);
        console.log(needItemIndex);
        this.items.splice(needItemIndex, 1);
        await axios.post(this.url + "crm.timeline.comment.delete", {
          id: item.id,
        });
      } catch (error) {
        console.log({ error });
      }
    },
    async upload(type) {
      try {
        this.disabled = true;
        let isConfirm = false;
        const getBase64 = (file) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64String = reader.result
                .replace("data:", "")
                .replace(/^.+,/, "");
              resolve(base64String);
              //console.log(base64String);
            };
            // console.log(file)
            reader.readAsDataURL(file);
          });
        if (type == "Принято") {
          if (confirm("Вы уверены что хотите принять раздел?")) {
            isConfirm = true;
            const files = [];
            const localFiles = [];
            for (const file of this.files) {
              files.push([file.name, await getBase64(file)]);
            }
            for (const localFile of this.localFiles) {
              localFiles.push([localFile.name, await getBase64(localFile)]);
            }
            if (localFiles.length > 0) {
              await axios.post(this.url + "crm.timeline.comment.add", {
                fields: {
                  ENTITY_ID: this.chatID,
                  ENTITY_TYPE: "Dynamic_180",
                  COMMENT: "Локальное заключение",
                  SETTINGS: { HAS_FILES: "Y" },
                  FILES: localFiles,
                },
              });
            }
            await axios.post(this.url + "crm.timeline.comment.add", {
              fields: {
                ENTITY_ID: this.chatID,
                ENTITY_TYPE: "Dynamic_180",
                COMMENT: "Принято",
                SETTINGS: { HAS_FILES: "Y" },
                FILES: files,
              },
            });
            //проверяем, есть ли папка, если есть, загружаем в папку последний файл,
            //проверяем есть ли папка
            if (
              this.deal.UF_CRM_1615451416891 &&
              this.deal.UF_CRM_1615451416891 != ""
            ) {
              const comments = await axios.post(
                this.url + "crm.timeline.comment.list",
                {
                  filter: {
                    ENTITY_ID: this.chatID,
                    ENTITY_TYPE: "Dynamic_180",
                  },
                }
              );
              console.log(comments);
              const fileID = Object.values(
                comments.data.result[comments.data.result.length - 2].FILES
              )[0].id;
              await axios.post(this.url + "disk.file.copyto", {
                id: fileID,
                targetFolderId: this.deal.UF_CRM_1615451416891,
              });
            } else {
              //если нет, создаем папку и загружаем последний файл
              const diskData = await axios.post(
                this.url + "disk.folder.addsubfolder",
                {
                  id: 429642,
                  data: {
                    NAME: `Разделы проектной документации по результатам экспертизы по сделке ${this.deal.TITLE}`,
                  },
                }
              );
              console.log({ diskData });
              await axios.post(this.url + "crm.deal.update", {
                id: this.deal.ID,
                fields: {
                  UF_CRM_1615451416891: diskData.data.result.ID,
                  UF_CRM_1714050302: diskData.data.result.DETAIL_URL,
                },
              });
              const comments = await axios.post(
                this.url + "crm.timeline.comment.list",
                {
                  filter: {
                    ENTITY_ID: this.chatID,
                    ENTITY_TYPE: "Dynamic_180",
                  },
                }
              );
              console.log(comments);
              const fileID = Object.values(
                comments.data.result[comments.data.result.length - 2].FILES
              )[0].id;
              await axios.post(this.url + "disk.file.copyto", {
                id: fileID,
                targetFolderId: diskData.data.result.ID,
              });
            }
          } else {
            isConfirm = false;
          }
        } else {
          isConfirm = true;
          const files = [];
          for (const file of this.files) {
            console.log(file);
            files.push([file.name, await getBase64(file)]);
          }
          await axios.post(this.url + "crm.timeline.comment.add", {
            fields: {
              ENTITY_ID: this.chatID,
              ENTITY_TYPE: "Dynamic_180",
              COMMENT: type,
              SETTINGS: { HAS_FILES: "Y" },
              FILES: files,
            },
          });
        }
        if (isConfirm) {
          await axios.post(this.url + "bizproc.workflow.start", {
            TEMPLATE_ID: 310,
            DOCUMENT_ID: [
              "crm",
              "Bitrix\\Crm\\Integration\\BizProc\\Document\\Dynamic",
              `DYNAMIC_180_${this.chatID}`,
            ],
            PARAMETERS: {
              isDone: type == "Принято" ? 1 : "",
              answer: type == "Клиент" ? 1 : "",
            },
          });
          location.reload(); //перезагрузить страницу
        }
        this.expertLocalMenu = false;
        this.expertMenu = false;
        this.disabled = false;
      } catch (e) {
        console.log(e);
      }
    },
    async download(type, file = {}) {
      async function delay(file) {
        const link = document.createElement("a");
        link.href = file.urlMachine;
        link.download = file.title;
        link.click();
      }
      //-----------------------------------
      if (type == "all") {
        for (const file of this.dealFiles) {
          await delay(file);
        }
      } else {
        await delay(file);
      }
    },
    async getComments() {
      this.loadingValue = 0;
      const comments = await axios.post(
        this.url + "crm.timeline.comment.list",
        {
          filter: {
            ENTITY_ID: this.chatID,
            ENTITY_TYPE: "Dynamic_180",
          },
        }
      );
      const oneItemPercent = 100 / comments.data.result.length;
      console.log({ oneItemPercent });
      for (const comment of comments.data.result) {
        console.log({ comment });
        if (comment.COMMENT != "Принято") {
          const date = new Date(comment.CREATED);
          const files = [];
          for (const fileIndex in comment.FILES) {
            const fileDisk = await axios.post(this.url + "disk.file.get", {
              id: comment.FILES[fileIndex].id,
            });
            const hash = await axios.post(
              "https://spa-bitrix.ru/expertNotice/crc32.php",
              { url: fileDisk.data.result.DOWNLOAD_URL },
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              }
            );
            files.push({
              id: comment.FILES[fileIndex].id,
              title: `${comment.FILES[fileIndex].name}`,
              hash: hash.data,
              urlMachine: fileDisk.data.result.DOWNLOAD_URL,
            });
          }
          this.items.push({
            id: comment.ID,
            type: comment.COMMENT.includes("Клиент") ? "answer" : "question",
            date: date.toLocaleDateString("ru-RU"),
            dateXls: date,
            files,
            localResult: comment.COMMENT.includes("Локальное заключение")
              ? "Локальное заключение"
              : "",
          });
          await axios.post(this.url + "crm.item.update", {
            id: this.chatID,
            entityTypeId: 180,
            fields: {
              stageId: "DT180_14:SUCCESS",
            },
          });
        } else {
          this.disabled = true;
        }
        this.loadingValue += oneItemPercent;
      }
    },
    async getData() {
      await this.getComments();
      console.log(this.items);
      if (this.items.length == 0) {
        this.lastDate = this.date.toLocaleDateString("ru-RU");
      } else {
        const lastDate = this.items[this.items.length - 1].dateXls.setDate(
          this.items[this.items.length - 1].dateXls.getDate() + 1
        );
        this.lastDate = new Date(lastDate).toLocaleDateString("ru-RU");
      }

      const sections = await axios.post(this.url + "lists.element.get", {
        IBLOCK_TYPE_ID: "lists",
        IBLOCK_ID: 56,
      });
      const chat = await axios.post(this.url + "crm.item.get", {
        entityTypeId: "180",
        id: this.chatID,
      });
      const expert = await axios.post(this.url + "lists.element.get", {
        IBLOCK_TYPE_ID: "lists",
        IBLOCK_ID: 46,
        ELEMENT_ID: chat.data.result.item.ufCrm8_1706282210,
      });
      console.log(expert.data.result[0].PROPERTY_196);
      const expertData = await axios.post(this.url + "lists.element.get", {
        IBLOCK_TYPE_ID: "lists",
        IBLOCK_ID: 50,
        ELEMENT_ID: Object.values(expert.data.result[0].PROPERTY_196)[0],
      });
      this.expert.name = expertData.data.result[0].NAME;
      this.expert.phone = expertData.data.result[0].PROPERTY_194
        ? Object.values(expertData.data.result[0].PROPERTY_194)[0]
        : "";
      this.expert.email = expertData.data.result[0].PROPERTY_192
        ? Object.values(expertData.data.result[0].PROPERTY_192)[0]
        : "";
      console.log({ expertData });
      const dealID = chat.data.result.item.parentId2;
      const deal = await axios.post(this.url + "crm.deal.get", {
        id: dealID,
      });
      this.deal = deal.data.result;
      console.log({ deal });
      this.title = deal.data.result.TITLE;
      this.obj = deal.data.result.COMMENTS;
      this.b24DiskUrl = deal.data.result.UF_CRM_1711468949508;
      console.log(this.diskURL, "diskURL");
      //this.dealFiles = chat.data.result.item.ufCrm8_1706513495;
      //const dealFilesName = chat.data.result.item.ufCrm8_1706537609320;
      //for (const index in dealFilesName) {
      //console.log(this.dealFiles);
      //this.dealFiles[index].title = dealFilesName[index];
      //}
      let length = 0;
      for (const index in expert.data.result[0].PROPERTY_230) {
        length += 1;
        console.log({ index });
        this.sections += `${
          sections.data.result.filter(
            (e) => e.ID == expert.data.result[0].PROPERTY_230[index]
          )[0].NAME +
          (length != Object.keys(expert.data.result[0].PROPERTY_230).length
            ? ", "
            : "")
        }`;
      }
    },
  },
  async created() {
    const date = new Date();
    this.nowDate = date.toLocaleDateString();
    console.log(this.nowDate, "nowDate");
    this.chatID = this.$route.query.chatID;
    this.isExpert = this.$route.query.expert ? this.$route.query.expert : false;
    this.isMobile = document.documentElement.clientWidth < 960 ? true : false;
    await this.getData();
  },
};
</script>
